import React from "react";
import { Bot, User } from "lucide-react";

export default function AgentConfigTab({
  selectedAgent,
  handleInputChange,
  formErrors = {},
}) {
  const currentGender = selectedAgent?.gender || selectedAgent?.voice_gender || "female";

  const genderOptions = [
    { label: "Female", value: "female", icon: <User size={15} /> },
    { label: "Male", value: "male", icon: <User size={15} /> }
  ];

  const handleGenderChange = (newGender) => {
    handleInputChange("gender", newGender);
    handleInputChange("voice_gender", newGender);
  };

  return (
    <div className="tab-panel-content">
      {/* SECTION 1: Greeting & Welcomes */}
      <div className="config-section-simple">
        {/* 1. Agent Name */}
        <div>
          <label className="field-label">
            Agent Name <span style={{ color: "#ef4444", marginLeft: "2px" }}>*</span>
          </label>
          <input
            type="text"
            className="field-input-textarea"
            style={{ 
              height: 42,
              border: formErrors.campaign_name ? "1px solid #ef4444" : undefined,
              boxShadow: formErrors.campaign_name ? "0 0 0 3px rgba(239, 68, 68, 0.15)" : undefined
            }}
            placeholder="Enter Agent..."
            value={selectedAgent?.campaign_name || ""}
            onChange={(e) => handleInputChange("campaign_name", e.target.value)}
          />
          {formErrors.campaign_name ? (
            <div style={{ color: "#ef4444", fontSize: "12px", fontWeight: 600, marginTop: "4px" }}>
              {formErrors.campaign_name}
            </div>
          ) : (
            <div className="field-helper">Unique label identifying this active voice agent campaign.</div>
          )}
        </div>

        {/* 2. Agent Description */}
        <div>
          <label className="field-label">
            Agent Description <span style={{ color: "#94a3b8", fontWeight: "normal", fontSize: "12px", marginLeft: "4px" }}>(Optional)</span>
          </label>
          <textarea
            className="field-input-textarea"
            rows={3}
            style={{ minHeight: "80px", padding: "10px 12px", resize: "vertical" }}
            placeholder="Enter a brief description of the agent's purpose or role..."
            value={selectedAgent?.description || selectedAgent?.campaign_description || ""}
            onChange={(e) => {
              handleInputChange("description", e.target.value);
              handleInputChange("campaign_description", e.target.value);
            }}
          />
          <div className="field-helper">Describe the purpose, target audience, or business goals for this agent.</div>
        </div>

        {/* 2. Agent Gender Radio Group */}
        <div>
          <label className="field-label" style={{ marginBottom: 10, display: "block" }}>Gender</label>
          <div style={{ display: "flex", alignItems: "center", gap: "14px", flexWrap: "wrap", marginTop: "6px" }}>
            {genderOptions.map((option) => {
              const isChecked = currentGender === option.value;
              return (
                <label
                  key={option.value}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "8px",
                    minWidth: "115px",
                    padding: "9px 16px",
                    borderRadius: "10px",
                    border: "1px solid",
                    borderColor: isChecked ? "var(--primary, #1e53b8)" : "var(--gray-200, #e2e8f0)",
                    backgroundColor: isChecked ? "rgba(30, 83, 184, 0.05)" : "var(--white, #ffffff)",
                    color: isChecked ? "var(--primary, #1e53b8)" : "var(--slate-700, #334155)",
                    fontWeight: 600,
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
                    boxShadow: isChecked ? "0 2px 8px rgba(30, 83, 184, 0.08)" : "none",
                    userSelect: "none",
                    boxSizing: "border-box"
                  }}
                >
                  <input
                    type="radio"
                    name="agent_gender"
                    value={option.value}
                    checked={isChecked}
                    onChange={(e) => handleGenderChange(e.target.value)}
                    style={{
                      accentColor: "var(--primary, #1e53b8)",
                      cursor: "pointer",
                      width: "16px",
                      height: "16px",
                      margin: 0
                    }}
                  />
                  <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                    {option.icon}
                  </span>
                  <span>{option.label}</span>
                </label>
              );
            })}
          </div>
          <div className="field-helper" style={{ marginTop: 8 }}>
            Selecting gender dynamically filters available voice characters in voice configuration.
          </div>
        </div>
      </div>
    </div>
  );
}
